import { render, staticRenderFns } from "./TrangImport.vue?vue&type=template&id=4ee53361&"
import script from "./TrangImport.vue?vue&type=script&lang=js&"
export * from "./TrangImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports